module.exports = __webpack_public_path__ + "media/images/favicon/ms-icon-70x70-dd6f7420d8f82ff5c07b6375f1ff47c5.png";